import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { ServingContainer } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface ServingContainerWatchProps {
    servingContainer?: ServingContainer;
}

export function ServingContainerInput({ disabled = false }: Props) {
    const { servingContainer } =
        useFormContext<ServingContainerWatchProps>().getValues();
    const servingContainerQueryResult = useQuery({
        queryKey: ['servingContainers'],
        queryFn: () =>
            Api.Servings.ServingContainer.getServingContainers({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: servingContainer ? [servingContainer] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Serving Container"
            name="servingContainerId"
            loading={servingContainerQueryResult.isLoading}
            multiple={false}
            options={servingContainerQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: ServingContainer,
                    value?: ServingContainer | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
            }}
        />
    );
}
